module.exports = __webpack_public_path__ + "static/geerntet-02-831143cbd2c3181c6a8df78bd06fe0ea.jpg";